
import React from "react";
import { getCountyFAQs } from "@/lib/county-faqs";
import { PageNavigation } from "@/components/nursing-homes/county/PageNavigation";
import { FilterSection } from "@/components/nursing-homes/county/FilterSection";
import { ResultsContainer } from "@/components/nursing-homes/county/ResultsContainer";
import { ContentSections } from "@/components/nursing-homes/county/ContentSections";
import type { NursingHomeFilters } from "@/hooks/use-county-page-data";

interface CountyPageContentProps {
  countyName: string;
  countySlug: string | undefined;
  nursingHomes: any[];
  nursingHomeCount: number;
  breadcrumbItems: { label: string; href: string }[];
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  sortBy: string;
  setSortBy: (sort: string) => void;
  selectedCounty: string | null;
  setSelectedCounty: (county: string | null) => void;
  countyOptions: { county: string; county_slug: string }[];
  countiesLoading: boolean;
  isLoading: boolean;
  error: Error | null;
  countyData: any;
  nearbyCounties: any[];
  filters?: NursingHomeFilters;
  setFilters?: (filters: NursingHomeFilters) => void;
  activeFilterCount?: number;
}

export function CountyPageContent({
  countyName,
  countySlug,
  nursingHomes,
  nursingHomeCount,
  breadcrumbItems,
  searchQuery,
  setSearchQuery,
  sortBy,
  setSortBy,
  selectedCounty,
  setSelectedCounty,
  countyOptions,
  countiesLoading,
  isLoading,
  error,
  countyData,
  nearbyCounties,
  filters,
  setFilters,
  activeFilterCount,
}: CountyPageContentProps) {
  // Get county-specific FAQs
  const countyFaqs = getCountyFAQs(countySlug || '');
  
  return (
    <div className="container py-12">
      <PageNavigation breadcrumbItems={breadcrumbItems} />
      
      <FilterSection 
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        sortBy={sortBy}
        setSortBy={setSortBy}
        selectedCounty={selectedCounty}
        setSelectedCounty={setSelectedCounty}
        countyOptions={countyOptions}
        countiesLoading={countiesLoading}
        nursingHomesCount={nursingHomeCount}
        countyName={countyName}
        filters={filters}
        setFilters={setFilters}
        activeFilterCount={activeFilterCount}
      />
      
      <ResultsContainer
        isLoading={isLoading}
        error={error}
        nursingHomes={nursingHomes}
        countyName={countyName}
        countySlug={selectedCounty || countySlug}
        searchQuery={searchQuery}
      />
      
      <ContentSections
        countyName={countyName}
        countySlug={countySlug || ''}
        countyDescription={countyData?.description}
        nursingHomeCount={nursingHomeCount}
        faqs={countyFaqs}
        nearbyCounties={nearbyCounties}
      />
    </div>
  );
}
